module.exports = __webpack_public_path__ + "img/Dantam Hair 18.0f9bbf10.jpg";